export enum PlayerState {
  SELECTED = "selected",
  DEFAULT = "default",
  DISABLED = "disabled",
  ACTIVE = "active",
}

export interface IPlayer {
  id: string;
  name: string;
  avatarUrl: string;
  state?: PlayerState;
}

export class GamePlayers {
  min: number;
  max: number | undefined;

  constructor(min: number, max: number | undefined) {
    this.min = min;
    this.max = max;
  }
}

export class Game {
  name: string;
  players: GamePlayers;
  equipment: Equipment[];
  duration: Duration;
  experience: Experience;
  online: boolean;

  constructor(
    name: string,
    players: GamePlayers,
    equipment: Equipment[],
    duration: Duration,
    experience: Experience,
    online: boolean
  ) {
    this.name = name;
    this.players = players;
    this.equipment = equipment;
    this.duration = duration;
    this.experience = experience;
    this.online = online;
  }
}

export enum Equipment {
  SCREEN = "screen",
  TABLE = "table",
  CHAIRS = "chairs",
  DESK = "desk",
}

export enum Duration {
  SHORT = "short",
  MEDIUM = "medium",
  LONG = "long",
}

export enum Experience {
  BEGINNER = "beginner",
  INTERMEDIATE = "intermediate",
  ADVANCED = "advanced",
}

export enum ProfessionType {
  REAL = "real",
  UNREAL = "unreal",
}

export enum Lang {
  RU = "ru",
  EN = "en",
}

export interface Localised<Type> {
  [Lang.RU]: Type;
  [Lang.EN]: Type;
}

export interface IProfession {
  id: string;
  type: ProfessionType;
  image: string;
  title: Localised<string>;
  description: Localised<string>;
}

export interface IPresentationGameConfig {
  randomTopic: boolean;
  customTopic: string;
  slideCount: number;
  autoNext: boolean;
  duration: number;
  showInstructions: boolean;
}

export interface ICharactersGroup {
  name: Localised<string>;
  characters: Localised<string>[];
}

export interface IInterestingDiscussionGameConfig {
  randomTopic: boolean;
  customTopic: string;
  selectedPlayerIds: string[];
  selectedCharactersGroupIndexes: number[];
}

export interface IConductedStoryGameConfig {
  randomTopic: boolean;
  customTopic: string;
  selectedPlayerIds: string[];
}

export interface Reviewer {
  name: Localised<string>;
  position: Localised<string>;
  photo: string;
}

export interface ReviewData {
  rating: number;
  comment: Localised<string>;
  details: Localised<string>;
  reviewer: Reviewer;
}

export type OnlyStringProps = {
    [key: string]: string;
};

export class TimeRange {
  min: number;
  max: number;

  constructor(min: number, max: number) {
    this.min = min;
    this.max = max;
  }

  getRandomInterval = () => {
    return Math.floor(Math.random() * (this.max - this.min) + this.min) * 1000;
  }
}

export enum LocalStorage {
  GAME_ID_STORAGE = "GAME_ID_STORAGE",
  PLAYERS_STORAGE = "PLAYERS_STORAGE",
  USER_ID_STORAGE = "USER_ID_STORAGE",
  SLIDES_STORAGE = "SLIDES_STORAGE",
  SLIDES_STORAGE_DATE = "SLIDES_STORAGE_DATE",
  USED_INSTRUCTIONS_STORAGE = "USED_INSTRUCTIONS_STORAGE",
  USED_TOPICS_STORAGE = "USED_TOPICS_STORAGE",
  USED_SLIDES_STORAGE = "USED_SLIDES_STORAGE",
  USED_CONDUCTED_STORY_TOPICS_STORAGE = "USED_CONDUCTED_STORY_TOPICS_STORAGE",
  VIEWED_PROFESSIONS_STORAGE = "VIEWED_PROFESSIONS_STORAGE",
  USED_DISCUSSION_TOPICS_STORAGE = "USED_DISCUSSION_TOPICS_STORAGE",
  USED_DISCUSSION_CHARACTERS_STORAGE = "USED_DISCUSSION_CHARACTERS_STORAGE",
}

export interface IGameDescription {
  description: string[],
  instruction: string[],
  videos: string[],
  variations: string[]
}
